import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight, Play } from 'lucide-react';
export function Hero() {
  return <section className="relative h-screen w-full overflow-hidden bg-neutral-950 flex items-center justify-center" data-id="element-103">
      {/* Background Image with Motion Blur Effect */}
      <div className="absolute inset-0 z-0" data-id="element-104">
        <div className="absolute inset-0 bg-gradient-to-t from-neutral-950 via-neutral-950/50 to-transparent z-10" data-id="element-105" />
        <div className="absolute inset-0 bg-red-900/20 mix-blend-overlay z-10" data-id="element-106" />
        <img src="https://images.unsplash.com/photo-1551698618-1dfe5d97d256?q=80&w=2070&auto=format&fit=crop" alt="Extreme Sports Action" className="w-full h-full object-cover opacity-60 scale-110 animate-pulse-slow" style={{
        filter: 'blur(2px)'
      }} data-id="element-107" />
      </div>

      {/* Decorative Speed Lines */}
      <div className="absolute inset-0 z-0 overflow-hidden opacity-20 pointer-events-none" data-id="element-108">
        {[...Array(5)].map((_, i) => <motion.div key={i} initial={{
        x: '-100%',
        opacity: 0
      }} animate={{
        x: '200%',
        opacity: [0, 1, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        delay: i * 0.4,
        ease: 'linear'
      }} className="absolute top-0 bottom-0 w-32 bg-gradient-to-r from-transparent via-white to-transparent skew-x-[-45deg]" style={{
        left: `${i * 20}%`
      }} data-id="element-109" />)}
      </div>

      <div className="relative z-20 container mx-auto px-4 text-center" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-111">
          <h2 className="text-red-600 font-bold tracking-[0.5em] uppercase mb-4 text-sm md:text-base" data-id="element-112">
            The Future of Extreme Gaming
          </h2>
          <h1 className="text-6xl md:text-8xl lg:text-9xl font-black text-white uppercase tracking-tighter mb-8 leading-[0.9] italic" data-id="element-113">
            Fuel Your <br data-id="element-114" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-600 to-red-800" style={{
            textShadow: '0 0 30px rgba(220, 38, 38, 0.5)'
          }} data-id="element-115">
              Adrenaline
            </span>
          </h1>
          <p className="max-w-2xl mx-auto text-neutral-400 text-lg md:text-xl mb-10 font-medium leading-relaxed" data-id="element-116">
            The world's first platform converging real-world extreme sports with
            high-octane competitive gaming. Join the rush.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-117">
            <Button size="lg" className="w-full sm:w-auto group" data-id="element-118">
              Join the Rush
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-119" />
            </Button>
            <Button variant="outline" size="lg" className="w-full sm:w-auto group" data-id="element-120">
              <Play className="mr-2 w-5 h-5 fill-current" data-id="element-121" />
              Watch Live
            </Button>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20 text-white flex flex-col items-center gap-2" animate={{
      y: [0, 10, 0]
    }} transition={{
      repeat: Infinity,
      duration: 1.5
    }} data-id="element-122">
        <span className="text-xs uppercase tracking-widest text-neutral-500" data-id="element-123">
          Scroll
        </span>
        <div className="w-[1px] h-12 bg-gradient-to-b from-red-600 to-transparent" data-id="element-124" />
      </motion.div>
    </section>;
}